import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.46038 12.4592L5.54114 11.54L9.08152 7.99961L5.54114 4.45923L6.46038 3.53999L10.92 7.99961L6.46038 12.4592Z"
      fill={props.fill || "var(--main-color)"}
    />
  </svg>
);
export default SVGComponent;
